import React from "react";
import PreloaderImage from "../assets/preloaders/preloader.gif";

const Preloader = () => {
  return (
    <div className="omnidox-preloader">
      <img src={PreloaderImage} alt="Loading..." />
    </div>
  );
};

export default Preloader;
